import { css } from '@emotion/react';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import Icon from '@veeva/corgix/icon';
import getTargetAttribute from '../../../../services/getTargetAttribute';

function EmailSuccess({ newEmail, labels }) {
    return (
        <div
            css={({ greenDefault }) => {
                return css`
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 1.667rem;
                    text-align: center;

                    svg[data-icon='check-circle'] {
                        width: 8.333rem;
                        height: 8.333rem;
                        color: ${greenDefault};
                    }
                `;
            }}
        >
            <div
                css={css`
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    font-weight: bold;
                `}
            >
                <span>{labels.confirmationSentLabel}</span>
                <span data-target={getTargetAttribute('email-success')}>{newEmail}</span>
            </div>
            <Icon type={faCheckCircle} />
            {labels.confirmationSentInstructionLabel}
        </div>
    );
}

export default EmailSuccess;
